export const getPresetAvatars = (baseUrl: string, avatarPrefix: string) => {
  const prefix = avatarPrefix ? `${avatarPrefix}-` : '';
  return [
    {
      id: 'female-avatar-1',
      alt: 'Female avatar 1',
      src: `https://${baseUrl}${prefix}default-01.png`,
    },
    {
      id: 'female-avatar-2',
      alt: 'Female avatar 2',
      src: `https://${baseUrl}${prefix}default-02.png`,
    },
    {
      id: 'female-avatar-3',
      alt: 'Female avatar 3',
      src: `https://${baseUrl}${prefix}default-03.png`,
    },
    {
      id: 'female-avatar-4',
      alt: 'Female avatar 4',
      src: `https://${baseUrl}${prefix}default-04.png`,
    },
    {
      id: 'male-avatar-1',
      alt: 'Male avatar 1',
      src: `https://${baseUrl}${prefix}default-05.png`,
    },
    {
      id: 'male-avatar-2',
      alt: 'Male avatar 2',
      src: `https://${baseUrl}${prefix}default-06.png`,
    },
    {
      id: 'male-avatar-3',
      alt: 'Male avatar 3',
      src: `https://${baseUrl}${prefix}default-07.png`,
    },
    {
      id: 'male-avatar-4',
      alt: 'Male avatar 4',
      src: `https://${baseUrl}${prefix}default-08.png`,
    },
    {
      id: 'faceless-avatar-1',
      alt: 'Faceless avatar 1',
      src: `https://${baseUrl}default.png`,
    },
    {
      id: 'faceless-avatar-2',
      alt: 'Faceless avatar 2',
      src: `https://${baseUrl}default-09.png`,
    },
    {
      id: 'faceless-avatar-3',
      alt: 'Faceless avatar 3',
      src: `https://${baseUrl}default-10.png`,
    },
    {
      id: 'faceless-avatar-4',
      alt: 'Faceless avatar 4',
      src: `https://${baseUrl}default-11.png`,
    },
  ];
};
